import script from "./ModalViewAdapter.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalViewAdapter.vue?vue&type=script&setup=true&lang=js"

import "./ModalViewAdapter.vue?vue&type=style&index=0&id=65a8cca2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65a8cca2"]])

export default __exports__